import { WebSocketSendRequestDataMessage } from './web-socket-send-request-data-message';

/**
 * Fetches every teammate's product signals for the company.
 *
 * The signed-in user's own signals are deliberately excluded by the backend - those come from
 * `get-highguide-product-signals` instead. Favorite-only signals are also filtered out server side, since they carry
 * no information worth surfacing and would only add noise.
 *
 * {
 *     "action": "DATA_REQUEST",
 *     "entityId": 21628856,
 *     "payload": {
 *         "companyId": 53714500,
 *         "locationId": 21628856,
 *         "requestId": "3ba67f5f-6916-4612-a742-2415d288f4cc",
 *         "userId": "3c60bae4-e945-4d01-a08f-9f886b6f9418",
 *         "dataType": "WebsocketDataRequestType_HighGuideCompanySignals",
 *         "metadata": {}
 *     }
 * }
 */
export class WebSocketRequestHighGuideCompanySignals extends WebSocketSendRequestDataMessage {
  constructor(userId: string, companyId: number, locationId: number) {
    super(locationId);
    this.payload.companyId = companyId;
    this.payload.locationId = locationId;
    this.payload.userId = userId;
    this.payload.dataType = 'WebsocketDataRequestType_HighGuideCompanySignals';
    this.payload.metadata = {};
  }
}
